// Copyright (c) 2026 Goffy. This file belongs to Goffy. All Rights Reserved.

import * as Crypto from 'expo-crypto';

/**
 * A v4 UUID for a new photo.
 *
 * The id is chosen client-side so the S3 prefix is decided once, before the presign, and the client
 * can key an optimistic tile against the row it is about to create. It **must** be a real UUID:
 * tour-service parses `photoId` as a `Guid` and the key layout embeds it as `{photoId:N}`, so an
 * ad-hoc string like `photo-<timestamp>` would be rejected at the API boundary.
 *
 * `expo-crypto` rather than the `crypto` global: Hermes has no `crypto`, and reading an undeclared
 * identifier throws outright rather than yielding undefined.
 */
export const newPhotoId = (): string => Crypto.randomUUID();
